import './blog-explore.component.pug'
import './blog-explore.component.scss'

import { Swiper } from 'swiper'

document.querySelectorAll('.blog-explore__slider').forEach((root) => {
  const swiperElement = root.querySelector('.swiper-container')
  if (swiperElement) {
    new Swiper(swiperElement, {
      slidesPerView: 1,
      spaceBetween: 20,
      breakpoints: {
        768: {
          slidesPerView: 2
        }
      }
    })
  }
})
